"use strict";
exports.__esModule = true;
exports.chart_color_gold_200 = {
  "name": "--pf-v5-chart-color-gold-200",
  "value": "#f6d173",
  "var": "var(--pf-v5-chart-color-gold-200, #f6d173)"
};
exports["default"] = exports.chart_color_gold_200;